import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { logOut } from "./auth/authSlice";
import { api as appApi } from "./api";
import { BASE_URL } from "./url";

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().userAuth.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

// Pages show `error.data.message`. Most endpoints send { status, message };
// a few older ones send { error } instead, network failures have no body, and
// a proxy error page arrives as a plain string.
const errorMessage = (error) => {
  if (error.status === "FETCH_ERROR") return "Network error. Check your connection and try again.";
  const data = error.data && typeof error.data === "object" ? error.data : {};
  const legacy = typeof data.error === "string" ? data.error : data.error?.message;
  if (error.status === 403) return data.message || legacy || "You don't have permission to do this";
  return data.message || legacy;
};

const customFetchBase = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  if (!result.error) return result;

  // Every invalid, expired or revoked token comes back as 401. Clear the
  // session locally: calling admins/logout would only fail again without a
  // valid token. Protected routes then redirect to /login.
  if (result.error.status === 401 && api.getState().userAuth.token) {
    api.dispatch(logOut());
    api.dispatch(appApi.util.resetApiState());
    return { ...result, error: { ...result.error, data: { ...result.error.data, message: "Login expired" } } };
  }

  const data = result.error.data && typeof result.error.data === "object" ? result.error.data : {};
  return { ...result, error: { ...result.error, data: { ...data, message: errorMessage(result.error) } } };
};

export default customFetchBase;
